export default __webpack_public_path__ + "locales/pl/EmptyTrashDialog.json?hash=8728ec56d81d83a2ffd7f399a7378682";